
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BlueDocumentIcon',

  props: {
    mimeTypeSlag: String
  }
})
